// 语言初始化模块 - 使用 cacheManager 优化缓存管理
import Util from 'utils';
import cacheManager from 'utils/cache/cacheManager';
const codeMap = {
  'zh-CN': 'cn',
  zh: 'cn',
  'ja-JP': 'ja',
  'ko-KR': 'ko',
  'en-US': 'en',
  'en-GB': 'en',
  'en-AU': 'en',
  'ms-MY': 'ms',
  'id-ID': 'id',
  'th-TH': 'th',
  'zh-TW': 'zh-tw',
  'ru-RU': 'ru',
  'km-KH': 'km',
  'my-MM': 'my',
  'vi-VN': 'vi',
  'lo-LA': 'lo',
  'de-DE': 'de' // 新增德语配置
};
// 避免循环依赖，直接定义 Language_MAP
export const Language_MAP = window.Language_MAP || {};

// 通用方法 校验语言是否存在于枚举表中，不存在则返回cn
export const languageValid = (val) => {
  if (codeMap[val]) return val;
  if (Language_MAP[val]) return val;
  return 'cn';
};

// 从设备中获取语言选项
export const getLanguage = () => {
  let val = navigator.language;
  return languageValid(val);
};

/**
 * 语言初始化函数
 * 负责设置当前语言和同步缓存数据
 * 使用 cacheManager 替代直接的 localStorage 操作，提供更好的缓存管理
 */
export const initLanguage = () => {
  // 1. 初始化当前语言
  const initCurrentLng = () => {
    let lng = 'cn'; // 默认中文

    // 从URL参数获取语言设置（优先级最高）
    const urlLng = Util.getQueryString('lng');
    if (urlLng && Language_MAP[urlLng]) {
      lng = urlLng;
      localStorage.setItem('lng', lng); // 语言设置本身仍使用localStorage存储
    } else {
      // 从localStorage获取语言设置
      const storageLng = localStorage.getItem('lng');
      if (storageLng && Language_MAP[storageLng]) {
        lng = storageLng;
      } else {
        // 使用浏览器语言设置
        lng = getLanguage();
      }
    }

    // 设置全局语言变量
    window.currentLng = lng;
    return lng;
  };

  const currentLng = initCurrentLng();

  // 2. 同步缓存数据
  const syncCache = () => {
    try {
      if (currentLng == 'cn') {
        console.log('中文不需要同步缓存');
        return;
      }
      // 构建带语言后缀的缓存键
      const cacheKey = `translation_${currentLng}`;

      // 从localStorage加载缓存到内存（使用cacheManager自动同步）
      // cacheManager会自动将本地缓存同步到内存缓存
      const translationJson = cacheManager.get(cacheKey) || {};

      // 检查window.translate是否存在并同步
      if (window.translate && typeof window.translate === 'object') {
        // 合并翻译数据
        const mergedTranslations = { ...translationJson, ...window.translate };
        // 使用cacheManager设置缓存
        cacheManager.set(cacheKey, mergedTranslations);
        // 标记语言包已加载
        if (cacheManager.memory) {
          cacheManager.memory.languageLoaded = true;
        }
      }
    } catch (error) {
      console.error('缓存同步失败:', error);
    }
  };

  // 执行缓存同步
  syncCache();

  return currentLng;
};

/**
 * 获取翻译文本
 * @param {string} text - 要翻译的文本
 * @param {boolean} save - 是否保存翻译结果
 * @returns {Promise<string>} - 翻译后的文本
 */
export const getTranslation = async (text, save = true) => {
  try {
    // 如果是中文，直接返回原文
    const currentLng = window.currentLng || 'cn';
    if (currentLng === 'cn') {
      return text;
    }

    // 构建带语言后缀的缓存键
    const cacheKey = `translation_${currentLng}`;

    // 从cacheManager获取缓存的翻译数据
    const translationJson = cacheManager.get(cacheKey) || {};

    // 检查是否已有缓存的翻译结果
    if (translationJson[text]) {
      return translationJson[text];
    }

    // TODO: 如果没有缓存的翻译结果，可以添加API调用逻辑
    // 这里保留原有的翻译API调用逻辑

    return text;
  } catch (error) {
    console.error('获取翻译失败:', error);
    return text;
  }
};

/**
 * 保存翻译结果到缓存
 * @param {string} text - 原始文本
 * @param {string} translatedText - 翻译后的文本
 */
export const saveTranslation = (text, translatedText) => {
  try {
    const currentLng = window.currentLng || 'cn';
    if (currentLng === 'cn') return;

    const cacheKey = `translation_${currentLng}`;
    const translationJson = cacheManager.get(cacheKey) || {};

    // 更新翻译数据
    translationJson[text] = translatedText;

    // 保存到缓存
    cacheManager.set(cacheKey, translationJson);
  } catch (error) {
    console.error('保存翻译结果失败:', error);
  }
};



// WEBPACK FOOTER //
// ./src/config/language/initLanguage.js